import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);

  const toggleMenu = () => {
    setIsMobile(!isMobile);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobile(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <ul className={isMobile ? 'nav-links active' : 'nav-links'}>
         <li><a href="#home">Home</a></li>
         <li><a href="#about">About Me</a></li>
         <li><a href="#services">Services</a></li>
         <li><a href="#projects">My Works</a></li>
        </ul>


        <div className="hamburger-menu" onClick={toggleMenu}>
          <div className={isMobile ? 'line line1 active' : 'line line1'}></div>
          <div className={isMobile ? 'line line2 active' : 'line line2'}></div>
          <div className={isMobile ? 'line line3 active' : 'line line3'}></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;